import React from "react";
import { useLocation } from "react-router-dom";
import PrintBooking from "./index";
const MultiPrint = () => {
  const location = useLocation();
  return <PrintBooking ids={location?.state} />;
};
export default MultiPrint;
